var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from "react";
import Helmet from "react-helmet";
import { Redirect, Route } from "react-router-dom";
import DefaultLayout from "src/Layout";
import LoadingProvider from "src/LoadingProvider";
// from https://gist.github.com/avinmathew/e82fe7e757b20cb337d5219e0ab8dc2c
export var Routes = function (_a) {
    var Component = _a.component, _b = _a.layout, Layout = _b === void 0 ? DefaultLayout : _b, showOnboarding = _a.showOnboarding, redirect = _a.redirect, title = _a.title, rest = __rest(_a, ["component", "layout", "showOnboarding", "redirect", "title"]);
    return (React.createElement(Route, __assign({}, rest, { render: function (props) {
            return showOnboarding || redirect ? (React.createElement(Redirect, { to: { pathname: "/", state: { redirect: false } } })) : (React.createElement(LoadingProvider, null,
                React.createElement(Layout, __assign({}, rest),
                    title && (React.createElement(Helmet, null,
                        React.createElement("title", null, title))),
                    React.createElement(Component, __assign({}, props, rest)))));
        } })));
};
export var AppRoute = Routes;
